"use strict";
var PZJscolor = function PZJscolor(props) {
    return React.createElement(
        React.Fragment,
        null,
        React.createElement("input", {
            id: "pzColorPicker",
            className: "jscolor-input {hash:true,styleElement:'',onFineChange:'jsColorOnFineChange(this)'}",
            value: props.value,
            onChange: function onChange() {},
            onFocus: function onFocus(e) {
                e.preventDefault(), props.showColorPicker(e);
            },
            maxLength: "7"
        })
    );
};
